import { Component, Input } from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import { Router } from '@angular/router';
import { NavigationEnd } from '@angular/router';

@Component({
  selector: 'site-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.css']
})
export class FooterComponent {

  private fragment: string;
  
  constructor(private route: ActivatedRoute, private router: Router) {

  this.router.events.subscribe(s => {
    if (s instanceof NavigationEnd) {
      const tree = router.parseUrl(router.url);
      if (tree.fragment) {
        const element = document.querySelector("#" + tree.fragment);
        if (element) { element.scrollIntoView(true); }
      }
    }
  });
 }

}


// WEBPACK FOOTER //
// /home/ppeters/filmCritClient/src/app/components/footer/footer.component.ts